export default "__VITE_ASSET__4857cd4a__"